module.exports = __webpack_public_path__ + "static/media/P20-sm-close.c72db610.svg";